module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0108.jpg?v=2a9ec41c";